// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";

export default class SaveIntermediateWaypointRequest {

    public id: string | null = null;

    public waypointId: string = "";

    public latitude: number = 0;

    public longitude: number = 0;

    public order: number = 0;

    public fairway: boolean = false;

    public readonly isSaveIntermediateWaypointRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof SaveIntermediateWaypointRequest) || ((from as any).isSaveIntermediateWaypointRequest === true));
    }

    public static as(from?: object | null): SaveIntermediateWaypointRequest | null {
        return (SaveIntermediateWaypointRequest.is(from)) ? from as SaveIntermediateWaypointRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(SaveIntermediateWaypointRequest, "SaveIntermediateWaypointRequest");